// School configuration based on environment
const isDevelopment = process.env.NODE_ENV === 'development';
const isProduction = process.env.NODE_ENV === 'production';

// Default school codes - can be overridden by environment variables
const DEFAULT_SCHOOL_CODES = {
  hmc: { name: 'HMC' },
  uw: { name: 'University of Washington' },
  'uw-cs': { name: 'University of Washington (CS Staff Only)' },
  caltech: { name: 'Caltech' },
  whitman: { name: 'Whitman College' },
  wellesley: { name: 'Wellesley College' },
  pomona: { name: 'Pomona College' },
};

// Default fallback schools - can be overridden by environment variables
const DEFAULT_FALLBACK_SCHOOLS = [
  { id: 1, name: 'HMC', auth_type: 'google_oauth', domain: 'g.hmc.edu' },
  { id: 2, name: 'Other', auth_type: 'password', domain: 'gmail.com' },
  { id: 11, name: 'University of Washington', auth_type: 'password', domain: 'uw.edu' },
  {
    id: 12,
    name: 'University of Washington (CS Staff Only)',
    auth_type: 'password',
    domain: 'cs.washington.edu',
  },
  { id: 13, name: 'Caltech', auth_type: 'password', domain: 'caltech.edu' },
  { id: 14, name: 'Pomona College', auth_type: 'password', domain: 'pomona.edu' },
  { id: 15, name: 'Whitman College', auth_type: 'password', domain: 'whitman.edu' },
  { id: 16, name: 'Wellesley College', auth_type: 'password', domain: 'wellesley.edu' },
];

// Parse school codes from environment variable if provided
const getSchoolCodesFromEnv = () => {
  const envCodes = process.env.REACT_APP_SCHOOL_CODES;
  if (!envCodes) return DEFAULT_SCHOOL_CODES;

  try {
    return JSON.parse(envCodes);
  } catch (error) {
    console.warn('Failed to parse REACT_APP_SCHOOL_CODES, using defaults:', error);
    return DEFAULT_SCHOOL_CODES;
  }
};

// Parse fallback schools from environment variable if provided
const getFallbackSchoolsFromEnv = () => {
  const envSchools = process.env.REACT_APP_FALLBACK_SCHOOLS;
  if (!envSchools) return DEFAULT_FALLBACK_SCHOOLS;

  try {
    return JSON.parse(envSchools);
  } catch (error) {
    console.warn('Failed to parse REACT_APP_FALLBACK_SCHOOLS, using defaults:', error);
    return DEFAULT_FALLBACK_SCHOOLS;
  }
};

// Main configuration object
export const schoolConfig = {
  // School codes for custom URLs
  SCHOOL_CODES: getSchoolCodesFromEnv(),

  // Fallback schools if API fails
  FALLBACK_SCHOOLS: getFallbackSchoolsFromEnv(),

  // API endpoint (can be overridden by environment)
  API_ENDPOINT: process.env.REACT_APP_API_URL || 'http://localhost:8000',

  // Enable debug logging in development
  DEBUG: isDevelopment || process.env.REACT_APP_DEBUG === 'true',
};

// Function to get school by code
export const getSchoolByCode = (code) => {
  if (!code) return null;
  const normalizedCode = code.toLowerCase();
  return schoolConfig.SCHOOL_CODES[normalizedCode] || null;
};

// Function to get all available codes
export const getAllSchoolCodes = () => {
  return Object.keys(schoolConfig.SCHOOL_CODES);
};

// Function to get sorted fallback schools
export const getSortedFallbackSchools = () => {
  return schoolConfig.FALLBACK_SCHOOLS.sort((a, b) => {
    if (a.name === 'Other') return 1;
    if (b.name === 'Other') return -1;
    return a.name.localeCompare(b.name);
  });
};

// Log configuration in development
if (schoolConfig.DEBUG) {
  console.log('School Configuration:', {
    environment: process.env.NODE_ENV,
    schoolCodes: Object.keys(schoolConfig.SCHOOL_CODES),
    fallbackSchoolsCount: schoolConfig.FALLBACK_SCHOOLS.length,
    apiEndpoint: schoolConfig.API_ENDPOINT,
  });
}
